<template>
  <v-select
    v-if="!isLoading"
    :items="items"
    v-model="model"
    label="Shop"
    item-text="name"
    item-value="id"
    :disabled="disabled"
    :rules="rules"
    hide-details="auto"
    :clearable="clearable"
  ></v-select>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      model: this.value,
      mandatoryRules: [v => !!v || "This fiels is mandatory"],
      message: null,
      search: null,
      isLoading: false,
      items: []
    };
  },
  props: {
    value: {
      type: Number
    },
    locationId: {
      type: Number
    },
    disabled: {
      type: Boolean
    },
    clearable: {
      type: Boolean,
      default: () => false
    },
    rules: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    model() {
      this.$emit("input", this.model);
    },
    value() {
      this.model = this.value;
    },
    locationId() {
      this.getShops();
    }
  },
  mounted: function() {
    this.getShops();
  },
  methods: {
    ...mapActions("shops", {
      viewShop: 'list'
    }),
    getShops() {
      this.viewShop()
        .then(({shops}) => {
          this.items = shops.data;
        })
        .finally(() => (this.isLoading = false));
    }
  }
};
</script>
